import styled, { css } from 'styled-components';
import theme from '../../styles/ThemeComponents';
import Tooltip from '../Tooltip';

interface ContainerProps {
  isFocused?: boolean;
  isFilled?: boolean;
  isErrored?: boolean;
}

export const ContainerRef = styled.div<ContainerProps>`
  display: flex;
  justify-content: stretch;
  align-items: center;

  background: ${theme.input.background};
  color: ${theme.input.color};
  border-radius: 10px;
  border: ${theme.input.border};
  padding: 0px 16px;
  position: relative;
  min-height: 60px;

  ${props => props.isErrored ? css`
    border: 2px solid red;
    border-radius: 5px;

` : ''}

  >span, >label{
    width: 100% !important;
    display: flex  !important;
    justify-content: space-between !important;
    align-items: center !important;
}

  .mandatoryInfo{
    background: red !important;
    color: #fff !important;
    border-radius: 3px !important;
    padding: 3px !important;
    font-size: 9px;
  }

  div.react-datepicker-popper{
    z-index: 1000;
  }

  > span {

    transition: 0.2s all;
    position: absolute;
    left: 0px; top: 15px;
    padding: 0px 16px;
    font-size: 0px;
  }


  ${props =>
    props.isErrored &&
    css`
      border-color: #c53030;

      > span {
        display: inline-block;
        position: absolute;
        top: 3px;
        left: 16px;
        color: #fff;
        font-size: 10px;
      }
    `}

    > span {
        display: inline-block;
        position: absolute;
        top: 3px;
        left: 16px;
        color: #fff;
        font-size: 10px;
      }

  ${props =>
    props.isFocused &&
    css`
      color: ${theme.input.colorFocused};
      border-color: ${theme.input.borderColorFocused};

      > span {
        display: inline-block;
        position: absolute;
        top: 3px;
        left: 16px;
        color: #fff;
        font-size: 10px;
      }
    `}

    ${props =>
    props.isFilled &&
    css`
        color: ${theme.input.colorFilled};
        > span {
          display: inline-block;
          position: absolute;
          top: 3px;
          left: 16px;
          color: #fff;
          font-size: 10px;
        }
      `}



  & + div {
    margin-top: 8px;
  }

  svg {
    font-size: 16px;
    margin-right: 16px;
  }



  input {
    width: 100%;
    border: 0;
    color: ${theme.input.color};
    padding: 16px;
    background: transparent;

    &::placeholder {
      color: #eee;
    }
  }
`;

export const Error = styled(Tooltip)`
  margin-left: 16px;
  height: 20px;

  span {
    background: red;
    color: #fff !important;

    &::before {
      border-color: red transparent;
    }
  }
  svg {
    margin-right: 0;
    color: #fff;
    font-size: 20px;
  }
`;
